import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <nav>
      <ul>
        <li>
          <Link to="/">home</Link>
        </li>
        <li>
          <Link to="/projects">projects</Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;